import React from 'react';
import ReactDOM from 'react-dom';

const ConfirmModal = ({ text, onConfirm, onCancel, confirmLoading = false }) =>
  ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm mx-4 shadow-2xl">
        <p className="text-sm text-gray-700 mb-5">{text}</p>
        <div className="flex space-x-3 justify-end">
          <button
            type="button"
            onClick={onCancel}
            disabled={confirmLoading}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
          >
            Abbrechen
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={confirmLoading}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md transition-colors flex items-center"
          >
            {confirmLoading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Bitte warten...
              </>
            ) : (
              'Bestätigen'
            )}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );

export default ConfirmModal;
